import styled from 'styled-components';
import { INACTIVE_GRAY, NIGHTINGALE_BLACK } from '../../colors';
import { getPx } from '../../helpers/common';
import { INPUT_HEIGHT, INPUT_HORIZONTAL_PADDING, INPUT_TEXT_WITH_ICON_LEFT_PADDING, INPUT_VERTICAL_PADDING } from '../../Input/constants';
import { onAutoFillCancel, onAutoFillStart } from '../../hooks/useAutofill';
import { Input as InputSize } from '../../Typography/constants/input.size';
import { baseTextStyle } from '../../Typography/style/base';
import { isDefined } from '../../helpers/defined';
import { baseHighlightStyle } from '../../tokens/highlight';
import { lineHeight } from '../../style/line-height';
import { fontSize } from '../../style/font-size';
import { paddingLeft } from '../../style/padding-left';
import { paddingRight } from '../../style/padding-right';
import { height, paddingVertical } from '../../style';
const FormField = styled.div`
  border-radius: 4px;
  border: none;
  flex-grow: 1;
  width: 100%;
  box-sizing: border-box;
  background-color: transparent !important; // to re-set all browsers pseudo-styles
  filter: none !important; // to re-set all browsers pseudo-styles
  color: ${NIGHTINGALE_BLACK};
  padding: 0 ${getPx(INPUT_HORIZONTAL_PADDING)};
  ${fontSize(InputSize.fontSize)}
  ${lineHeight(InputSize.lineHeight)}
  ${baseTextStyle}
  ${baseHighlightStyle}
  ${({
  $withIcon
}) => $withIcon ? paddingLeft(INPUT_TEXT_WITH_ICON_LEFT_PADDING) : ''}
  ${({
  $withRightIcon
}) => $withRightIcon ? paddingRight(INPUT_TEXT_WITH_ICON_LEFT_PADDING) : ''}
  ${({
  $resize
}) => isDefined($resize) ? `resize: ${$resize};` : ''}
  
  ${({
  multiple,
  $multiline
}) => !multiple && !$multiline ? height(INPUT_HEIGHT) : ''}
  ${paddingVertical(INPUT_VERTICAL_PADDING)}
  
  &:active, &:focus {
    outline: none;
  }
  ::placeholder {
    -webkit-text-fill-color: ${INACTIVE_GRAY};
    color: ${INACTIVE_GRAY};
    font-weight: 400;
    opacity: 1; // Firefox workaround
  }
  ::-ms-clear {
    display: none;
  }
  ::-ms-reveal {
    display: none;
  }
  ::-ms-value {
    background-color: transparent;
  }

  transition: background-color 99999s, color 0.2s ease-out, filter 99999s;
  &:-webkit-autofill {
    transition: background-color 99999s, color 99999s, filter 99999s;
    animation-name: ${onAutoFillStart};
  }
  &:not(:-webkit-autofill) {
    animation-name: ${onAutoFillCancel};
  }

  &:invalid {
    box-shadow: none; // Firefox workaround
  }

  ${({
  disabled
}) => disabled ? `
        opacity: 1; // iOS workaround
        -webkit-text-fill-color: ${INACTIVE_GRAY};
        color: ${INACTIVE_GRAY};
        cursor: not-allowed;
        pointer-events: all;
      ` : ''}
  ${({
  $withPrefix
}) => $withPrefix ? `
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      ` : ''}
  ${({
  $withSuffix
}) => $withSuffix ? `
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      ` : ''}
  
  ${({
  $truncateValue
}) => $truncateValue && `
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  `}
`;
export default FormField;